import { useState } from 'react';
import ContactModal from './ContactModal';

export default function Footer() {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <footer className="relative text-center text-white overflow-hidden min-h-screen md:h-[700px]">
      {/* Background image layer */}
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-cover opacity-60"
        style={{
          backgroundImage: "url('/images/resources/footer.webp')",
        }}
      ></div>

      {/* Fade overlays */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/90"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-black/90"></div>

      {/* Foreground content */}
      <div className="relative z-10 flex flex-col items-center justify-center py-32 sm:py-40 md:py-96 lg:py-56 px-4">
        <h4 className="text-5xl md:text-8xl font-lato font-light mb-8 sm:mb-5 mt-[180px] md:mt-[-35px]">
          Ready to Start?
        </h4>
        <div className="mt-2 sm:mt-0 font-lato sm:text-xs md:text-sm">
          <button
            onClick={() => setModalOpen(true)}
            className="bg-transparent border border-white text-white px-6 py-2 font-semibold hover:bg-white hover:text-black active:bg-white active:text-black transition"
          >
            Contact Us
          </button>
        </div>
      </div>

      {/* Logo + bottom lines + text container */}
  <div className="absolute z-10 mt-auto w-full -bottom-6 sm:-bottom-6 md:-bottom-6 lg:-bottom-5">
    {/* Logo centered */}
    <div className="flex justify-center mb-2">
      <img
        src="/images/dimensi-sinergi.png"
        alt="Logo"
        className="w-16 sm:w-16 iphone-xr-landscape:w-20 md:w-32 h-auto mb-4"
      />
    </div>

    {/* Colored lines */}
    <div className="flex justify-center items-center w-full mb-2">
      <div className="h-[1px] bg-blue-500 w-1/2"></div>
      <div className="h-[1px] bg-red-500 w-1/2"></div>
    </div>

    {/* Bottom text row */}
    <div className="flex flex-row justify-between items-center px-2 md:px-6 text-[8px] md:text-xs text-white space-y-2 md:space-y-0 mb-6">
      <span>© 2025 PT. Dimensi Sinergi Gemilangindo</span>
      <span>Images for illustrative purposes only</span>
    </div>
  </div>

      {/* Modal */}
      <ContactModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />
    </footer>
  );
}
